import translate from '@translate';
import { ConstantsCodeType, ConstantsCodesObjectType } from 'src/types/constantsCodes';

/** Hodnoty SOURCE_SYS u produktů (viz core ProductsService) — nejsou stejné jako sourceSysCodes u vratek. */
export function getProductSourceSysSelectOptions(): ConstantsCodeType[] {
    return [
        { value: 'myskladon', label: translate('products.table.sourceSys.myskladon') },
        { value: 'pipes', label: translate('products.table.sourceSys.pipes') },
        { value: 'api', label: translate('products.table.sourceSys.api') },
    ];
}

export function getProductSourceSysCodesObject(): ConstantsCodesObjectType {
    return getProductSourceSysSelectOptions().reduce<ConstantsCodesObjectType>((acc, item) => {
        acc[String(item.value)] = item;
        return acc;
    }, {});
}
